export interface Product {
  id: string;
  title: string;
  description: string;
  image: string;
  category: string;
  price: string;
  botLink: string;
  features: string[];
  hasAppAccess?: boolean;
  appFeatures?: string[];
}

export const products: Product[] = [
  {
    id: '1',
    title: 'Plano OVER',
    description: 'Acesso completo a todo conteúdo via Telegram e Web App',
    image: '/images/plano-over.jpg',
    category: 'Mensalidade',
    price: 'R$ 69,90/mês',
    botLink: 'https://t.me/erohome_bot?start=over',
    features: ['Acesso total', 'Web App', 'Telegram', 'Conteúdo VIP'],
    hasAppAccess: true,
    appFeatures: [
      'Chat ao vivo com modelos',
      'Biblioteca exclusiva',
      'Notificações em tempo real',
      'Modo discreto',
      'Multi-dispositivos',
    ],
  },
  {
    id: '2',
    title: 'Troca de Casais',
    description: 'Conectamos casais para experiências inesquecíveis',
    image: '/images/swing.jpg',
    category: 'Encontros',
    price: 'R$ 22,90',
    botLink: 'https://t.me/erohome_bot?start=trocacasais',
    features: ['Verificado', 'Discreto', 'Casais reais'],
  },
  {
    id: '3',
    title: 'Bonde dos Cornos',
    description: 'A comunidade mais quente para quem adora compartilhar',
    image: '/images/corno.jpg',
    category: 'Comunidade',
    price: 'R$ 29,90',
    botLink: 'https://t.me/erohome_bot?start=bonde',
    features: ['Grupo VIP', 'Ao vivo', 'Interação'],
  },
  {
    id: '4',
    title: 'Ghotrix',
    description: 'As melhores góticas rabudas em conteúdo exclusivo',
    image: '/images/ghotrix.jpg',
    category: 'Modelos',
    price: 'R$ 27,90',
    botLink: 'https://t.me/erohome_bot?start=ghotrix',
    features: ['Góticas', 'Conteúdo +18', 'Atualizado diariamente'],
  },
  {
    id: '5',
    title: 'BR PLUS',
    description: 'O melhor do conteúdo brasileiro selecionado',
    image: '/images/br-plus.jpg',
    category: 'Nacional',
    price: 'R$ 69,90',
    botLink: 'https://t.me/erohome_bot?start=brplus',
    features: ['Brasileiras', 'Exclusivo', 'HD'],
  },
  {
    id: '6',
    title: 'Chamadas Ao Vivo',
    description: 'Videochamadas via API Telegram com as modelos mais gostosas (Pacotes de 15, 30 ou 60 minutos)',
    image: '/images/live.jpg',
    category: 'Ao Vivo',
    price: 'Relativo',
    botLink: 'https://t.me/erohome_bot?start=chamadas',
    features: ['1h de chamada', 'Modelos verificadas', 'Privado'],
  },
];
